import classNames from "classnames";
import {SyntheticEvent} from "react";

import {ButtonProps} from "../Button.types";

export type LinkButtonProps = Pick<
  ButtonProps,
  "children" | "typography" | "size" | "customClassName" | "isDisabled"
> &
  React.AnchorHTMLAttributes<HTMLAnchorElement>;

function LinkButton({
  customClassName,
  href,
  size = "regular",
  typography = "body",
  children,
  isDisabled,
  ...otherProps
}: LinkButtonProps) {
  const className = classNames(
    "button",
    "link-button",
    customClassName,
    `typography--${typography}`,
    {[`button--disabled`]: isDisabled},
    `button--${size}`
  );

  return (
    <a
      href={href}
      className={className}
      target={"_blank"}
      rel={"noopener noreferrer"}
      onClick={handleClick}
      {...otherProps}>
      {children}
    </a>
  );

  function handleClick(event: SyntheticEvent) {
    if (otherProps.onClick) {
      otherProps.onClick(event as any);
    }
  }
}

export default LinkButton;
